import React, { Component } from 'react'

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

class DownloadForm extends Component {

  state = {
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    sendTo: this.props.sendTo,
    subject: this.props.subject,
    isSubmitting: false,
  }

  constructor(props) {
    super(props)
    this.form = React.createRef()
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false

    // Disable the submit button
    this.setState({ isSubmitting: true })

    fetch("https://hooks.zapier.com/hooks/catch/2181815/3uh7ou3/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        ...this.state,
      }),
    })
      .then(() => {
        this.setState({ result: "success" })
      })
      .catch(error => this.setState({ result: "fail", msg: error }))
      .finally(() => {
        // Re-enable the submit button after the request completes
        this.setState({ isSubmitting: false })
      });
  }

  render() {

    let { download } = this.props
    let { result } = this.state

    let props = {
      ref: this.form,
      name: 'download',
      className: 'form form--download',
      onSubmit: this.handleSubmit,
    }

    if (result === 'success') {
      return (
        <div className='popup__success'>
          { this.props.formThanks && <p dangerouslySetInnerHTML={{ __html: this.props.formThanks }} /> }
          <a className='btn' href={download} target='_blank' rel='noopener noreferrer' download>Download</a>
        </div>
      )
    }

    return (

      <form {...props}>

        { this.props.formTitle && <p dangerouslySetInnerHTML={{ __html: this.props.formTitle }} /> }

        { this.state.msg && <div className='error'>{ this.state.msg }</div> }

        <div className='form__row form__row--double'>
          <div className='form__col'>
            <label htmlFor='first-name-field'> First Name </label>
            <input type='text' name='firstname' id='first-name-field' className='form__input' onChange={this.handleChange} required />
          </div>
          <div className='form__col'>
            <label htmlFor='first-name-field'> Last Name </label>
            <input type='text' name='lastname' id='first-name-field' className='form__input' onChange={this.handleChange} required />
          </div>
        </div>
        <div className='form__row form__row--double'>
          <div className='form__col'>
            <label htmlFor='email-field'> Email address </label>
            <input type='text' name='email' id='email-field' className='form__input' onChange={this.handleChange} required />
          </div>
          <div className='form__col'>
            <label htmlFor='email-field'> Phone </label>
            <input type='text' name='phone' id='phone-field' className='form__input' onChange={this.handleChange} required />
          </div>
        </div>

        <div className='form__row form__row--submit'>
          <button type='submit' className='btn btn--border btn--download-insights'  disabled={this.state.isSubmitting}>Download</button>
        </div>

      </form>
    )
  }
}

export default DownloadForm